import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";

const Alarm = ({ model, isDetailed, showSpinner, hideSpinner }) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    <DeviceControlButton
      buttonLabel={model.isOn() ? "Turn Off" : "Turn On"}
      onTap={() => {
        showSpinner(
          `Turning ${model.isOn() ? "off" : "on"} '${model.get("name")}'`
        );
        model.toggleAlarm().then(hideSpinner, hideSpinner);
      }}
    />
  </CommonControlWrapper>
);
Alarm.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default Alarm;



// WEBPACK FOOTER //
// ./src/components/Controls/Alarm.jsx